import React from "react";
import SearchIcon from "../../assets/icons/SearchIcon";
import styles from "./Input.module.scss";

const Input = ({ placeholder, search = false, value, onChange }) => {
  return (
    <div className={styles.headerInputContainer}>
      <input
        type="text"
        placeholder={placeholder}
        className={styles.headerInput}
        value={value}
        onChange={onChange}
      />

      {search && <SearchIcon className={styles.headerSearchIcon} />}
    </div>
  );
};

export default Input;
